var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height align-center justify-center",attrs:{"no-gutters":""}},[(_vm.$vuetify.breakpoint.smAndDown)?_c('v-btn',{staticClass:"mr-1",attrs:{"small":"","fab":"","depressed":"","icon":""},on:{"click":_vm.show}},[_c('v-icon',[_vm._v(" mdi-arrow-left-bold-circle-outline ")])],1):_vm._e(),_vm._v(" No setting selected ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }